var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ctitcomp"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.entrypoint}})])}
var staticRenderFns = []

export { render, staticRenderFns }